module.exports = __webpack_public_path__ + "87032851c3532c9dd64f20f4bee155a9.svg";